import React, { useEffect, useState } from "react";
import { useParams, NavLink, useLocation } from "react-router-dom";
import innerBanner from "../assets/images/inner-banner.png";
import symbols from "../assets/images/symbols.png";
import axios from "axios";
import EnquiryForm from "./EnquiryForm";

const ProductDetails = () => {
  const { id } = useParams();
  const location = useLocation();

  const [product, setProduct] = useState(location.state?.product || null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchProduct = async () => {
      if (!product) {
        try {
          const res = await axios.get("/allData.json");
          const found = res.data.Data.find((p) => String(p.id) === String(id));
          setProduct(found || null);
        } catch (err) {
          console.error("API Error:", err);
        }
      }
    };
    fetchProduct();
  }, [id, product]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  if (!product) {
    return <p style={{ textAlign: "center", marginTop: "50px" }}>Loading product...</p>;
  }

  return (
    <>
      <section id="inner-banner-wrapper">
        <div className="banner-image">
          <img className="w-100" src={innerBanner} alt="Contact Banner" />
        </div>
        <div className="breadcrumb">
          <h2>Products</h2>
          <ul>
            <li>
              <NavLink to="/">Home &gt; </NavLink>
            </li>
            <li>
              <NavLink to="/products">Products &gt; </NavLink>
            </li>
            <li>{product.code}</li>
          </ul>
        </div>
      </section>

      <div id="product-detail-wrapper">
        <div className="container">
          <div className="product-detail-head">
            {/* <button className="open-btn" onClick={() => setOpen(true)}>
              Enquiry
            </button>
            {open && (
              <div className="modal-overlay">
                <div className="modallbox">
                  <button className="close-btn" onClick={() => setOpen(false)}>
                    ✖
                  </button>
                
                </div>
              </div>
            )} */}

            <p>{product.discription}</p>
            <div className="details">
              <span className="product-code">{product.code}</span>
              <span className="cas-number">CAS No: {product.caseNumber}</span>
            </div>
            <div className="enqurir-form">
               <EnquiryForm discription={product.discription} code={product.code} caseNumber={product.caseNumber} />

            </div>

             
          </div>

          {/* <div className="product-detail-content">
            <div className="product-detail-left">
              <div className="physical-spec-wrapper">
                <div className="physical">
                  <h3>Physical</h3>
          <ul>
                  <li>
                    <h5>Form:</h5>
                    <span>solid</span>
                  </li>
                  <li>
                    <h5>Colour:</h5>
                    <span>white</span>
                  </li>
                  <li>
                    <h5>Melting point:</h5>
                    <span>888.00°C</span>
                  </li>
                  <li>
                    <h5>Boiling point:</h5>
                    <span>1429°C</span>
                  </li>
                  <li>
                    <h5>Density:</h5>
                    <span>2.70g/cm³</span>
                  </li>
                  <li>
                    <h5>Mol Weight:</h5>
                    <span>142.04g/mol</span>
                  </li>
                  <li>
                    <h5>Storage temp:</h5>
                    <span>RT</span>
                  </li>
                  <li>
                    <h5>Empirical formular:</h5>
                    <span>Na2SO4</span>
                  </li>
                  <li>
                    <h5>Type of packaging:</h5>
                    <span>glass bottle</span>
                  </li>
                  <li>
                    <h5>ACS:</h5>
                    <span>ACS</span>
                  </li>
                </ul>
                </div>

                <div className="spec">
                  <h3>Spec</h3>
                 
                <ul>
                  <li>
                    <h5>Form:</h5>
                    <span>solid</span>
                  </li>
                  <li>
                    <h5>Colour:</h5>
                    <span>white</span>
                  </li>
                  <li>
                    <h5>Melting point:</h5>
                    <span>888.00°C</span>
                  </li>
                  <li>
                    <h5>Boiling point:</h5>
                    <span>1429°C</span>
                  </li>
                  <li>
                    <h5>Density:</h5>
                    <span>2.70g/cm³</span>
                  </li>
                  <li>
                    <h5>Mol Weight:</h5>
                    <span>142.04g/mol</span>
                  </li>
                  <li>
                    <h5>Storage temp:</h5>
                    <span>RT</span>
                  </li>
                  <li>
                    <h5>Empirical formular:</h5>
                    <span>Na2SO4</span>
                  </li>
                  <li>
                    <h5>Type of packaging:</h5>
                    <span>glass bottle</span>
                  </li>
                  <li>
                    <h5>ACS:</h5>
                    <span>ACS</span>
                  </li>
                </ul>
                </div>
              </div>

              <div className="safety">
                <div className="spec">
                  <h3>Safety</h3>
                 
                <ul>
                  <li>
                    <h5>Form:</h5>
                    <span>solid</span>
                  </li>
                  <li>
                    <h5>Colour:</h5>
                    <span>white</span>
                  </li>
                  <li>
                    <h5>Melting point:</h5>
                    <span>888.00°C</span>
                  </li>
                  <li>
                    <h5>Boiling point:</h5>
                    <span>1429°C</span>
                  </li>
                  <li>
                    <h5>Density:</h5>
                    <span>2.70g/cm³</span>
                  </li>
                </ul>
                </div>
              </div>

              <div className="symbols">
                <h3>Symbols</h3>
                <img src={symbols} alt="symbols" />
              </div>
            </div>

           <div className="product-detail-right">
              <div className="product-detail-table">
                <table>
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th>Packing Sizes</th>
                    <th>Packing per Unit Box</th>
                    <th>Bottles per Pallet</th>
                    <th>Quantity</th>
                    <th>Price/Pack</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      Sodium sulfate Picograde anhydrous, granular for residue
                      analysis (ACS)
                    </td>
                    <td>0.5Kg</td>
                    <td>6</td>
                    <td>96</td>
                    <td>
                      <div className="table-quantity">
                        <button>+</button>
                        <input type="number" min="1" value="1" />
                        <button>-</button>
                      </div>
                    </td>
                    <td>€ 26.00</td>
                  </tr>

                  <tr>
                    <td>
                      Sodium sulfate Picograde anhydrous, granular for residue
                      analysis (ACS)
                    </td>
                    <td>0.5Kg</td>
                    <td>6</td>
                    <td>96</td>
                    <td>
                      <div className="table-quantity">
                        <button>+</button>
                        <input type="number" min="1" value="1" />
                        <button>-</button>
                      </div>
                    </td>
                    <td>€ 26.00</td>
                  </tr>

                  <tr>
                    <td>
                      Sodium sulfate Picograde anhydrous, granular for residue
                      analysis (ACS)
                    </td>
                    <td>0.5Kg</td>
                    <td>6</td>
                    <td>96</td>
                    <td>
                      <div className="table-quantity">
                        <button>+</button>
                        <input type="number" min="1" value="1" />
                        <button>-</button>
                      </div>
                    </td>
                    <td>€ 26.00</td>
                  </tr>

                  <tr>
                    <td>
                      Sodium sulfate Picograde anhydrous, granular for residue
                      analysis (ACS)
                    </td>
                    <td>0.5Kg</td>
                    <td>6</td>
                    <td>96</td>
                    <td>
                      <div className="table-quantity">
                        <button>+</button>
                        <input type="number" min="1" value="1" />
                        <button>-</button>
                      </div>
                    </td>
                    <td>€ 26.00</td>
                  </tr>

                  <tr>
                    <td>
                      Sodium sulfate Picograde anhydrous, granular for residue
                      analysis (ACS)
                    </td>
                    <td>0.5Kg</td>
                    <td>6</td>
                    <td>96</td>
                    <td>
                      <div className="table-quantity">
                        <button>+</button>
                        <input type="number" min="1" value="1" />
                        <button>-</button>
                      </div>
                    </td>
                    <td>€ 26.00</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ProductDetails;
